'use client';

import type { FC } from 'react';
import type { LinkProps } from '@/ui/components/Link/Link';
import Link from '@/ui/components/Link/Link';
import Typography from '@/ui/components/Typography/Typography';
import { useGA4 } from '@/ui/context/ga4';

import $ from './FooterLink.module.scss';

export type FooterLinkProps = LinkProps & {
  trackTitle?: string;
};

const FooterLink: FC<FooterLinkProps> = ({
  children,
  trackTitle,
  ...props
}) => {
  const { trackMenuNavigation } = useGA4();

  return (
    <Link
      {...props}
      className={$.footerLink}
      onClick={() => {
        props.onClick?.();
        trackMenuNavigation({
          menu: 'footer',
          menu_path: props.href,
          menu_text:
            typeof children === 'string' ? children : trackTitle ?? null,
          menu_click: 'text',
        });
      }}
    >
      <Typography variant="bodyMedium" className={$.footerLinkText}>
        {children}
      </Typography>
    </Link>
  );
};

export default FooterLink;
